import { connect } from 'react-redux';
import {
  getSelectedAddress,
  editAddressLoading,
  getAddressInError,
} from 'redux/modules/address/selectors';
import {
  onSubmitEditAddress as onSubmit,
  reportAddressPropertiesEdited,
  addressApiError,
} from 'redux/modules/address/actions';
import {
  addressSelector,
  foundAddress,
  hasFoundAddress,
} from 'redux/modules/address-suggestion/selectors';
import { getFeatureFlags as getFeatures } from 'utils/feature-flags';
import { flattenAddress, combineAddress, formatContactNumber } from '../util';
import EditAddress from './EditAddress';

export const formatAddress = address => (dispatch, getState) => {
  const state = getState();
  const selectedAddress = getSelectedAddress(state) || {};
  const flattenedAddress = flattenAddress(selectedAddress);
  const { id: suggestionId = null } = addressSelector(state);

  return {
    ...flattenedAddress,
    ...address,
    contactNumber: formatContactNumber(address.contactNumber || flattenedAddress.contactNumber),
    control: flattenedAddress,
    suggestionId,
  };
};

export const mapStateToProps = (state, props) => {
  const selectedAddress = getSelectedAddress(state) || {};
  const control = flattenAddress(selectedAddress);
  const { onAfterSubmit, ukOnlyAddress, manualOnly = true } = props;
  const { myWaitrose = false } = selectedAddress;
  const found = foundAddress(state);
  const addressInError = getAddressInError(state);

  const initialValues = hasFoundAddress(state)
    ? { ...combineAddress(found, control), control }
    : { ...control, control };

  const mappedProps = {
    editMode: false,
    initialValues,
    hasFoundAddress: true,
    loading: editAddressLoading(state),
    loadingMessage: 'Saving your address',
    hasError: addressInError !== null,
    manualOnly,
    ukOnlyAddress: ukOnlyAddress || myWaitrose,
    onAfterSubmit,
  };

  if (!getFeatures(state).manualAddressFormOnly) {
    return { ...mappedProps, manualOnly: false };
  }

  return mappedProps;
};

export const mapDispatchToProps = (dispatch, props) => {
  const onError = (error, address) => {
    if (error && error.status) {
      dispatch(addressApiError(address));
      return { hasError: true };
    }
    throw error;
  };

  return {
    onSubmit: async address => {
      const addressValues = dispatch(formatAddress(address));
      await dispatch(reportAddressPropertiesEdited(addressValues));

      return props.onSubmit
        ? props
            .onSubmit(addressValues)
            .then(value => props.onAfterSubmit(value))
            .catch(error => onError(error, addressValues))
        : dispatch(onSubmit(addressValues))
            .then(value => props.onAfterSubmit(value))
            .catch(error => onError(error, addressValues));
    },
    onApiError: address => dispatch(addressApiError(address)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditAddress);
